import React from 'react';

// Mui
import { Grid, Button } from '@mui/material';
import { Autorenew, SkipNext } from '@mui/icons-material';

function ValidationActionButtons(props) {
  return (
    <Grid container display="flex" alignItems="center" justifyContent="flex-end" gap="12px">
      <Grid item>
        <Button
          size="small"
          variant={'outlined'}
          disabled={props.disabled}
          onClick={() => {
            props.close();
          }}
          sx={{
            textTransform: 'none',
            fontSize: '14px',
            border: 'none',
            '&:hover': { border: 'none' },
          }}
          id="close-fix-errors-btn"
        >
          Close
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant={'outlined'}
          color={'primary'}
          disabled={props.disabled}
          onClick={() => {
            props.handlePublish();
          }}
          startIcon={<SkipNext />}
          sx={{ textTransform: 'none', fontSize: '14px' }}
          id="fix-errors-publish-anyway-btn"
        >
          Publish anyway
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant={'contained'}
          color={'primary'}
          onClick={() => {
            props.fireValidateDialog('publish');
          }}
          disabled={props.disabled}
          startIcon={<Autorenew />}
          sx={{ textTransform: 'none', fontSize: '14px' }}
          id="fix-errors-check-again-btn"
        >
          Check again
        </Button>
      </Grid>
    </Grid>
  );
}

export default ValidationActionButtons;
